import { render, staticRenderFns } from "./DoctorSelection.vue?vue&type=template&id=1f91bb68&scoped=true"
import script from "./DoctorSelection.vue?vue&type=script&lang=ts"
export * from "./DoctorSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f91bb68",
  null
  
)

export default component.exports